import { trpc } from '@/shared/api';

interface InvalidateExhibitions {
  /** 목적 목록만 — 목적 추가·이름 변경·재배치. */
  readonly invalidatePurposes: () => void;
  /** 한 목적의 기획전 목록 — 기획전 추가·이동·공개 전환·이미지 교체·삭제. */
  readonly invalidateExhibitions: (purposeId: string) => void;
  /** 목적 목록과 기획전 목록 전체 — 목적 삭제(기획전이 함께 지워진다)·기획전의 목적 변경. */
  readonly invalidateAll: () => void;
  /** 묶인 상품 목록과 기획전 목록 — 연결이 바뀌면 공개 상품 수·최소 수량도 바뀐다. */
  readonly invalidateExhibitionProducts: (exhibitionId: string, purposeId: string) => void;
}

/** 기획전 화면의 캐시 무효화 묶음 — 바뀐 범위만큼만 다시 불러온다. */
export const useInvalidateExhibitions = (): InvalidateExhibitions => {
  const utils = trpc.useUtils();
  const purposes = utils.productManagement.exhibitionPurposes.list;
  const exhibitions = utils.productManagement.exhibitions.list;
  const exhibitionProducts = utils.productManagement.exhibitions.listProducts;

  return {
    invalidatePurposes: () => void purposes.invalidate(),
    invalidateExhibitions: (purposeId) => void exhibitions.invalidate({ purposeId }),
    invalidateAll: () => {
      void purposes.invalidate();
      void exhibitions.invalidate();
    },
    invalidateExhibitionProducts: (exhibitionId, purposeId) => {
      void exhibitionProducts.invalidate({ exhibitionId });
      void exhibitions.invalidate({ purposeId });
    },
  };
};
